import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAuth0, authHttpInterceptorFn } from '@auth0/auth0-angular';

import { routes } from './app.routes';
import { API_BASE_URL } from './core/http/api-base';
import { TranslationService } from './core/i18n/translation';
import { HUB_URL } from './core/realtime/hub-config';
import { RealtimeService } from './core/realtime/realtime';

const API_BASE = 'https://api.test.bauforce.at';
const AUTH_DOMAIN = 'bauforce.eu.auth0.com';
const AUTH_CLIENT_ID = '0D51K4QO7Vvpdmj8sSC5nWLE9Bugxuol';
const AUTH_AUDIENCE = 'bauforce-audience';
const AUTH_SCOPE = 'openid profile email';
/**
 * SignalR hub route. It is not part of the OpenAPI document, so it has to be
 * taken from the BE's `MapHub<T>("...")` registration — set the path here and
 * nothing else needs to change. Set to '' to run without realtime.
 */
const HUB_PATH = '/hubs/entity-changes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([authHttpInterceptorFn])),
    provideAuth0({
      domain: AUTH_DOMAIN,
      clientId: AUTH_CLIENT_ID,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: AUTH_AUDIENCE,
        scope: AUTH_SCOPE,
      },
      httpInterceptor: {
        allowedList: [
          {
            uri: `${API_BASE}/*`,
            tokenOptions: {
              authorizationParams: {
                audience: AUTH_AUDIENCE,
              },
            },
          },
        ],
      },
    }),
    { provide: API_BASE_URL, useValue: API_BASE },
    { provide: HUB_URL, useValue: HUB_PATH ? `${API_BASE}${HUB_PATH}` : '' },
    // Load the active language bundle before the first render so no raw keys flash.
    provideAppInitializer(() => inject(TranslationService).init()),
    // Not awaited: a slow or unreachable hub must never hold up the first paint.
    provideAppInitializer(() => {
      void inject(RealtimeService).start();
    }),
  ],
};
